<template lang="pug">
v-dialog(v-model="showDialog" persistent :fullscreen="$vuetify.breakpoint.xs" max-width="600" )
    v-card.d-flex.flex-column
        v-card-title.headerline {{ data.title }}
        v-card-text(v-if="data.infoText")
            span {{ data.infoText }}
        v-card-text.flex-shrink-0.flex-grow-1
            v-list(v-if="data.errorResponse")
                v-list-item-group {{ $t('errorResponseDialog.violationListGroupLabel') }}
                v-list-item(v-for="(violation, idx) in data.errorResponse.response.data.violations" :key="idx")
                    v-list-item-icon.mx-0
                        v-icon(x-small) fas fa-chevron-right
                    v-list-item-content {{ getMessage(violation.message) }}
        v-divider
        v-card-actions
            v-spacer
            v-btn(color="primary" text @click="onCloseButtonClick") {{ $t('errorResponseDialog.closeButtonLabel') }}
</template>

<script lang="ts">
import Vue from 'vue'
import { ERROR_RESPONSE_DIALOG_DATA, SHOW_ERROR_RESPONSE_DIALOG } from '@/store/getter-types'
import { HIDE_RESPONSE_ERROR_DIALOG } from '@/store/action-types'

export default Vue.extend({
  name: 'ErrorResponseDialog',

  computed: {
    showDialog (): boolean {
      return this.$store.getters[SHOW_ERROR_RESPONSE_DIALOG]
    },

    data (): any {
      return this.$store.getters[ERROR_RESPONSE_DIALOG_DATA]
    },
  },

  methods: {
    onCloseButtonClick (): void {
        this.$store.dispatch(HIDE_RESPONSE_ERROR_DIALOG)
    },

    getMessage (item: string): string {
      let message: string = ''
      if(item === 'This value is already used.') {
        message = 'Zadaný názov už existuje'
      }
      return message
    }
  }
})
</script>

<style lang="stylus" scoped>

</style>
